<script setup lang="ts">
import type { ContentNavigationItem } from '@nuxt/content'

const navigation = inject<Ref<ContentNavigationItem[]>>('navigation', ref([]))
const route = useRoute()
const config = useRuntimeConfig()

const { data: page } = await useAsyncData(route.path, () => queryCollection('content').path(route.path).first())
if (!page.value) {
  throw createError({ statusCode: 404, fatal: true })
}

useSeoMeta({
  title: page.value.seo.title,
  description: page.value.seo.description,
})
</script>

<template>
  <div v-if="page.extension === 'md'">
    <UContainer>
      <UPage>
        <UPageHeader :title="page.title" />

        <UPageBody>
          <ContentRenderer :value="page" />
        </UPageBody>
      </UPage>
    </UContainer>
  </div>
  <div v-else>
    <UPageHero :title="page.meta.hero.title" :links="page.meta.hero.links" :orientation="page.meta.hero.orientation ? page.meta.hero.orientation : page.meta.hero.img ? 'horizontal' : 'vertical'" :headline="page.meta.hero.headline">
      <template #default>
        <NuxtImg v-if="page.meta.hero.img" :src="page.meta.hero.img" class="w-full" />
      </template>
      <template #description>
        <MDC :value="page.meta.hero.description" unwrap="p"/>
      </template>
      <template #headline="{orientation}" v-if="page.meta.breadcrumb">
        <UBreadcrumb :items="page.meta.breadcrumb" :ui="{list: page.meta.hero.orientation ? page.meta.hero.orientation : page.meta.hero.img ? '' : 'justify-center'}" />
      </template>
    </UPageHero>
    <SectionManager :sections="page.meta.sections">
      <template #team-section="{ section }">
        <UContainer>
          <UPageGrid class="xl:grid-cols-4">
            <UPageCard
                v-for="(user, index) in section.items"
                :key="index"
                :title="user.name"
                :description="user.location"
                :ui="{
                  wrapper: 'items-center',
                  container: 'gap-y-4 lg:py-8',
                  leading: 'flex justify-center',
                  title: 'text-center',
                  description: 'text-center text-muted'
                }"
            >
              <template #leading>
                <UAvatar v-bind="user.avatar" size="4xl" class="mx-auto" />
              </template>

              <div class="flex items-center justify-center gap-1.5 mt-4">
                <UButton v-for="(link, i) in user.links" :key="i" color="gray" variant="link" v-bind="link" target="_blank" external rel="nofollow noopener noreferrer" />
              </div>
            </UPageCard>
          </UPageGrid>
          <div class="my-8">
            Il ont contribué par le passé à l'aventure
            <span v-for="(user, i) in section.former" :key="i">
            <ULink color="gray" :to="user.link" target="_blank" external rel="nofollow noopener noreferrer">{{user.name}}</ULink><span v-if="i === section.former.length - 2"> & </span><span v-if="i < section.former.length - 2">, </span>
          </span>
          </div>
        </UContainer>
      </template>

      <template #timeline-section="{ section }">
        <UPageSection title="Notre histoire">
          <UChangelogVersions>
            <UChangelogVersion v-for="(step, i) in section.items" :key="i" :title="step.title" :description="step.description"/>
          </UChangelogVersions>
        </UPageSection>
      </template>

    </SectionManager>
  </div>
</template>